import type { AvailabilityEvent, ZCalendarEvent } from '../constants';
import { Z_CALENDAR_EVENT_TYPE } from '../constants';

export const getIsAvailabilityEvent = (event: ZCalendarEvent): boolean => {
  return event.eventType === Z_CALENDAR_EVENT_TYPE.AVAILABILITY;
};

export const getIsTourEvent = (event: ZCalendarEvent): boolean => {
  return event.eventType === Z_CALENDAR_EVENT_TYPE.TOUR;
};

export const getIsRecurringAvailabilityEvent = (event: ZCalendarEvent): boolean => {
  return getIsAvailabilityEvent(event) && (event as AvailabilityEvent).isRecurringEvent;
};

export const getIsInProgressAvailabilityEvent = (event: ZCalendarEvent): boolean => {
  return event.eventType === Z_CALENDAR_EVENT_TYPE.IN_PROGRESS_AVAILABILITY;
};

export const getIsEventDragAndDroppable = (event: ZCalendarEvent): boolean => {
  return getIsAvailabilityEvent(event) && !getIsRecurringAvailabilityEvent(event) && !event.isPastEvent;
};
